import { useCentrifugo } from '@/composables/useCentrifugo'
import { notificationService } from '@/utils/notifications'

import { hasOrderNum } from './mutations'
import { normalizePlayEvent, normalizePlayState } from './validators'

const { rpc } = useCentrifugo()

const showRpcError = (error, title) => {
    console.error(title, error)
    notificationService.showError(error, title, { timeout: false })
}

const callRpc = async (method, data, errorTitle) => {
    try {
        const result = await rpc(method, data)
        return result.data
    } catch (error) {
        showRpcError(error, errorTitle)
        throw error
    }
}

const requireAssignmentId = assignmentId => {
    if (typeof assignmentId !== 'string' || !assignmentId) {
        throw new Error('Не указан идентификатор назначения')
    }
}

const markStateSyncError = error => {
    if (!(error instanceof Error)) return error

    const stateSyncError = new Error(error.message)
    stateSyncError.stack = error.stack
    stateSyncError.cause = error
    stateSyncError.isStateSyncError = true

    return stateSyncError
}

const syncStateAfterRpc = dispatch =>
    dispatch('fetchState').catch(error => {
        console.error('[WS: Play] Состояние Play не синхронизировано', error)
        throw markStateSyncError(error)
    })

export default {
    async handleEvent({ state, commit }, data) {
        let event
        try {
            event = normalizePlayEvent(data)
        } catch (error) {
            console.warn('[WS: Play] Пропущено некорректное событие', error)
            return
        }

        if (event.type === 'assignment_offered') {
            const isDuplicate =
                state.assignment?.assignment_id === event.payload.assignment_id
            const bringsOrderNum =
                hasOrderNum(event.payload) && !hasOrderNum(state.assignment)

            if (isDuplicate && !bringsOrderNum) return

            commit('SET_ASSIGNMENT', event.payload)
            return
        }

        if (event.type === 'assignment_resolved') {
            if (
                state.assignment?.assignment_id === event.payload.assignment_id
            ) {
                commit('CLEAR_ASSIGNMENT')
            }
            return
        }

        if (event.payload.state_version <= state.stateVersion) return

        commit('APPLY_STATUS', {
            enabled: event.payload.play_enabled,
            stateVersion: event.payload.state_version,
        })
        if (
            event.payload.reason === 'auto_stop' &&
            !event.payload.play_enabled
        ) {
            notificationService.showWarning(
                'Play автоматически остановлен после пропущенных предложений',
                'Play остановлен',
                { timeout: false }
            )
        }
    },

    async fetchState({ commit }) {
        const data = await callRpc(
            'play.state',
            {},
            'Не удалось получить состояние Play'
        )
        const playState = normalizePlayState(data)
        commit('APPLY_STATE', playState)
        return playState
    },

    async start({ dispatch }) {
        await callRpc('play.start', {}, 'Не удалось включить Play')
        return syncStateAfterRpc(dispatch)
    },

    async stop({ dispatch }) {
        await callRpc('play.stop', {}, 'Не удалось выключить Play')
        return syncStateAfterRpc(dispatch)
    },

    async accept(_, assignmentId) {
        requireAssignmentId(assignmentId)
        return callRpc(
            'play.accept',
            { assignment_id: assignmentId },
            'Не удалось принять заказ'
        )
    },

    async decline(_, assignmentId) {
        requireAssignmentId(assignmentId)
        return callRpc(
            'play.decline',
            { assignment_id: assignmentId },
            'Не удалось отклонить заказ'
        )
    },
}
